module.exports = __webpack_public_path__ + "img/gr-sign.5696bca3.svg";